<template>
  <v-slide-x-reverse-transition>
    <div v-show="$route.query.asset && slide" class="asset-overlay">
      <div class="overlay-container">
        <div class="inner-overlay-container pa-0">
          <div
            :elevation="0"
            :loading="isLoading"
            class="asset-card elevation-0 layout column"
            color="white"
            light
            tile
          >
            <v-layout class="content-area-nomax" fill-height>
              <v-flex class="overflow scroll pa-3 pt-4 preview">
                <slot name="preview-area" />
                <slide-group-alert
                  v-if="slide && slide._id && slide.country"
                  :slide="slide"
                  :is-visible="
                    !$store.getters['localization/isMaster'] && localization && localization.localization_mode
                  "
                  @end-localization="localization.localization_mode = false"
                />

                <div class="mb-2 layout align-center sticky">
                  <div class="back">
                    <v-btn color="primary" text @click.stop="$router.back()">&#8592; Back</v-btn>
                  </div>
                  <v-spacer />
                  <div class>
                    <core-menu label="Group Navigation">
                      <template v-slot:menu>
                        <v-list dense>
                          <v-list-item
                            v-for="item in group"
                            :key="item._id"
                            @click.stop="$router.push({ query: { asset: item._id } })"
                          >
                            <v-list-item-content>
                              <v-list-item-title>{{ item.name }}</v-list-item-title>
                              <v-list-item-subtitle
                                >{{ item.externalId }} - {{ item.type.toUpperCase() }}
                                {{ item._id === $route.query.asset ? '- CURRENT' : '' }}</v-list-item-subtitle
                              >
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </template>
                    </core-menu>
                  </div>
                </div>
                <v-slide-y-transition>
                  <div v-show="message.needsMessageBlock" class="message-box">
                    <v-banner single-line sticky>
                      <v-icon slot="icon" size="36px">{{ icons.alert }}</v-icon>
                      <div>{{ message.msg }}</div>
                      <template v-if="message.action" v-slot:actions>
                        <v-btn
                          :loading="isLoading"
                          color="secondary"
                          text
                          @click.stop="messageActions(message.action)"
                          >{{ message.actionText }}</v-btn
                        >
                      </template>
                    </v-banner>
                  </div>
                </v-slide-y-transition>

                <image-helper
                  v-if="slide.asset"
                  with-action-bar
                  highlight-texts
                  class="elevation-6 mb-3"
                  :src="mainSrc"
                  :active-task="activeTask ? activeTask._id : null"
                  :see-tasks="showTasksOverlay"
                  :is-registered-for-deletion="slide.deletion.willDelete"
                  :tasks="tasks"
                  with-interaction
                >
                  <template slot="bottom-overlay" slot-scope="{ hover, src }">
                    <image-action-bar
                      v-if="slide.asset"
                      :history="slide.asset.history"
                      :hover="hover"
                      :src="src"
                    />
                  </template>
                </image-helper>
                <image-helper
                  v-if="
                    slide &&
                      slide.references &&
                      slide.references.slide &&
                      slide.references.slide.active &&
                      slide.references.refs.length > 0
                  "
                  class="elevation-4"
                  :src="slide.references.slide.asset.png"
                />
                <child-container
                  :sortable="true"
                  class="mt-2"
                  document-key="animationSlides"
                  slide-type="animation"
                  title="Animation Slides"
                />
                <child-container
                  :sortable="true"
                  document-key="popupSlides"
                  slide-type="popup"
                  title="Popup Slides"
                />
                <child-container
                  :sortable="false"
                  document-key="secondarySlides"
                  slide-type="subslide"
                  subslide
                  title="Deep Content Slides"
                />
              </v-flex>
              <v-flex class="meta layout column px-0">
                <save-button :visible="showSaveButton" label="Save" @click="save" />
                <save-button
                  label="Save References"
                  :visible="showReloadReferenceButton"
                  @click.stop="triggerSaveReference"
                />
                <v-dialog v-model="dialogs.references" width="700px">
                  <template v-slot:activator="{ on }">
                    <add-button
                      :visible="showAddReferenceButton"
                      :icon="icons.add"
                      label="Add Reference"
                      v-on="on"
                    />
                  </template>
                  <reference-assign-dialog @close="dialogs.references = false" />
                </v-dialog>
                <v-dialog v-model="dialogs.tasks" fullscreen transition="dialog-bottom-transition">
                  <template v-slot:activator="{ on }">
                    <add-button :visible="showAddTaskButton" :icon="icons.add" label="Add Task" v-on="on" />
                  </template>

                  <!--
        <task-comment-screen :src="src"/>
                  -->
                  <task-editor @close="dialogs.tasks = false" />
                </v-dialog>

                <!-- <add-button
                  v-on:click="$router.push({query: { ...$route.query, interaction: slide._id }})"
                  :visible="showAddInteractionButton"
                  :icon="icons.add"
                  label="Add Interaction"
                ></add-button>-->

                <slot name="meta-area" />
                <div ref="header" class="static">
                  <asset-header class="pa-3" :_id="$route.query.asset" />
                  <status-engine
                    v-if="slide && slide.status && slide.workflowStatus && slide.inArchive !== true"
                    :is-blocked="slide && slide.isBlocked === true"
                    :blocked-by="slide.downloaded && slide.downloaded.user ? slide.downloaded.user : null"
                    :initial-workflow-status="slide.workflowStatus"
                    class="px-3"
                    :initial-status="slide.status"
                  />
                  <from-archive :id="slide._id" v-if="slide && slide.inArchive" />
                  <div class="navigation full-width">
                    <v-tabs v-model="site" show-arrows :mobile-break-point="50" grow class="underlined">
                      <v-tab>Info</v-tab>
                      <v-tab>Ref.</v-tab>
                      <v-tab>Action</v-tab>
                      <v-tab>Tasks</v-tab>
                      <v-tab>Editor</v-tab>
                    </v-tabs>
                  </div>
                </div>
                <div class="subview fill-height">
                  <v-fade-transition group>
                    <!-- <meta-data :site="site" :slide="slide"/> -->
                    <meta-list v-if="site === 0" key="0" :slide="slide" />
                    <references v-if="site === 1" key="1" :slide="slide" />
                    <interactions v-if="site === 2" key="2" :slide="slide" />
                    <tasks v-if="site === 3" key="3" :slide="slide" />
                    <cms-editor v-if="site === 4" key="4" :slide="slide" />
                  </v-fade-transition>
                </div>
                <!-- <action-list class="pa-3"></action-list> -->
                <!-- <div class="pa-0">
                  <meta-data :site="site" :slide="slide"/>
                </div>-->
                <!-- <v-bottom-navigation shift v-model="site" color="primary" class="sdp-bottom-nav" flat absolute>
                  <v-btn @click.stop="$router.push({ query: { ...$route.query, site: 'meta' } })">
                    <span>Meta</span>
                    <v-icon :color="(site === 0) ?'primary': ''">{{ icons.navigation.meta }}</v-icon>
                  </v-btn>
                  <v-btn @click.stop="$router.push({ query: { ...$route.query, site: 'references' } })">
                    <span>References</span>
                    <v-icon :color="(site === 1) ?'primary': ''">{{ icons.references }}</v-icon>
                  </v-btn>
                  <v-btn @click.stop="$router.push({ query: { ...$route.query, site: 'interactions' } })">
                    <span>Interactions</span>
                    <v-icon :color="(site === 2) ?'primary': ''">{{ icons.interaction }}</v-icon>
                  </v-btn>
                  <v-btn @click.stop="$router.push({ query: { ...$route.query, site: 'tasks' } })">
                    <span>Todos</span>
                    <v-icon :color="(site === 3) ?'primary': ''">{{ icons.todos.todo }}</v-icon>
                  </v-btn>
                  <v-btn @click.stop="$router.push({ query: { ...$route.query, site: 'texts' } })">
                    <span>Texts</span>
                    <v-icon :color="(site === 4) ?'primary': ''">{{ icons.navigation.text }}</v-icon>
                  </v-btn>
                </v-bottom-navigation>-->
              </v-flex>
            </v-layout>
          </div>
        </div>
      </div>
    </div>
  </v-slide-x-reverse-transition>
</template>

<script>
import { mapState } from 'vuex';
import icons from '@/mixins/icons';
import moment from 'moment';
import ImageHelperVue from '@/components/img/ImageHelper.vue';
import ChildSlidesContainerVue from '../group/subcomponents/ChildSlidesContainer.vue';
import ImageActionBarVue from '../annotation-modal/ImageActionBar.vue';
import { SDP_PAGES_INTERFACE } from '../../config/constants';
import AssetHeaderComponentVue from './subcomponents/AssetHeaderComponent.vue';
import AssetMetaDataListVue from '../meta-data-table/AssetMetaDataList.vue';
import SaveButtonVue from '../core/buttons/SaveButton.vue';
import AddContentButtonVue from '../core/buttons/AddContentButton.vue';
import ReferenceAssignDialogVue from '../dialogs/ReferenceAssignDialog.vue';
import InteractionView from '@/components/interaction/Interaction-View';
import TodoListVue from '../todos/TodoList.vue';
import TypoToolComponentVue from '../group/subcomponents/TypoToolComponent.vue';
import StatusEngineVue from '../core/views/StatusEngine.vue';
import Editor from '@/components/slides/editor';
import CoreMenuVue from '../core/menu/CoreMenu.vue';
import SlideGroupAlert from '../localization/slide-group-alert';
import { EventBus } from '../../event-bus';
import SlideReferenceContainer from '@/components/references/SlideReferenceContainer.vue';
import AssetFromArchiveComponent from './subcomponents/AssetFromArchiveComponent.vue';

export default {
  components: {
    SlideGroupAlert,
    imageHelper: ImageHelperVue,
    childContainer: ChildSlidesContainerVue,
    imageActionBar: ImageActionBarVue,
    assetHeader: AssetHeaderComponentVue,
    metaList: AssetMetaDataListVue,
    saveButton: SaveButtonVue,
    statusEngine: StatusEngineVue,
    references: SlideReferenceContainer,
    addButton: AddContentButtonVue,
    referenceAssignDialog: ReferenceAssignDialogVue,
    interactions: InteractionView,
    tasks: TodoListVue,
    taskEditor: Editor,
    coreMenu: CoreMenuVue,
    cmsEditor: TypoToolComponentVue,
    fromArchive: AssetFromArchiveComponent
  },
  mixins: [icons],
  data() {
    return {
      isLoading: true,
      mini: true,
      site: this.$router.currentRoute.query.site || 0,
      headerHeight: 200,
      localization: null,
      dialogs: {
        references: false,
        tasks: false
      }
    };
  },
  computed: {
    subViewHeight() {
      return {
        height: `calc(100% - ${this.headerHeight}px) !important`
      };
    },
    ...mapState('slides', {
      slide: state => state.active,
      group: state => state.group
    }),

    message() {
      if (this.slide && this.slide.deletion && this.slide.deletion.willDelete) {
        return {
          needsMessageBlock: true,
          msg: `Slide will be deleted ${moment(this.slide.deletion.willDeletedAfter).fromNow()}.`,
          actionText: 'Undo',
          action: 'undo_deletion'
        };
      }

      if (
        this.slide &&
        this.slide.deletion &&
        this.slide.status === 'in_progress' &&
        this.slide.downloaded &&
        this.slide.downloaded.bool === true
      ) {
        return {
          needsMessageBlock: true,
          msg: `Slide is checked out by ${this.slide.downloaded.email}.`
        };
      }

      return {
        needsMessageBlock: false
      };
    },
    ...mapState('tasks', {
      tasks: state => state.items,
      activeTask: state => state.active,
      showTasksOverlay: state => state.behavior.showTasksOverlay
    }),
    ...mapState('navigation', {
      showSaveButton: state => state.buttons.sdp.save.visible,
      showAddReferenceButton: state => state.buttons.sdp.addReference.visible,
      showAddInteractionButton: state => state.buttons.sdp.addInteraction.visible,
      showAddTaskButton: state => state.buttons.sdp.addTask.visible,
      showReloadReferenceButton: state => state.buttons.sdp.reloadReferences.visible
    }),
    mainSrc() {
      if (this.$route.query.version) {
        return `https://storage.googleapis.com/slides-png/${this.$route.query.version}.png`;
      } else {
        return this.slide.asset.public.png;
      }
    }
  },
  watch: {
    '$route.query.asset': function(n, o) {
      this.getAll();
    },
    'slide.workflowStatus': function(o, i) {}
  },
  mounted() {
    const overlay = JSON.parse(localStorage.getItem('task-overlay'));
    this.$store.commit('tasks/toggleShowTaskOverlay', overlay);

    this.getAll();
    this.site = SDP_PAGES_INTERFACE[this.$route.query.site || 'meta'];

    this.mini = JSON.parse(localStorage.getItem('sdp-nav'));
    this.headerHeight = this.$refs.header.clientHeight + this.$refs.header.offsetTop;
  },
  methods: {
    triggerSaveReference() {
      EventBus.$emit('save-reference', true);
    },
    save(e) {},
    boxSizing() {
      const openSize = '256px';
      const closedSize = '80px';
      return {
        sitebar: {
          width: this.mini ? closedSize : openSize
        },
        container: {
          marginLeft: this.mini ? closedSize : openSize,
          width: `calc(100% - ${this.mini ? closedSize : openSize})`
        }
      };
    },
    getAll() {
      // this.isLoading = true;
      this.$store
        .dispatch('getAllForAsset', this.$route.query.asset)
        .then(async () => {
          try {
            const { data } = await this.$store.dispatch('slides/getLocalizationForSlide');
            this.localization = data.getSiblingForSlaveByLocale;
          } catch (e) {}
          this.isLoading = false;
        })
        .catch(_ => {
          this.isLoading = false;
        });
    },
    async messageActions(action) {
      switch (action) {
        case 'undo_deletion':
          this.isLoading = true;
          await this.$store.dispatch('slides/updateActiveSlide', {
            _id: this.slide._id,
            deletion: { willDelete: false }
          });
          this.isLoading = false;
          break;

        default:
          break;
      }
    }
  }
};
</script>

<style>
.v-overlay__content {
  width: 100% !important;
  height: 100% !important;
}
</style>
<style lang="scss" scoped>
.underlined::after {
  content: '';
  width: 100%;
  height: 1px;
  background-color: rgba(0, 0, 0, 0.12);
  position: absolute;
  margin-top: -1px;
}
.subview {
  overflow-y: scroll;
  position: relative;
}
$width: 256px;
.asset-overlay {
  z-index: 1000;
  position: absolute;
  width: 100%;
  height: 100%;
  right: 0;
  background-color: white !important;
}
.sdp-bottom-nav {
  position: absolute;
  bottom: 0px;
  box-shadow: none !important;
  border-top: 1px solid rgba(0, 0, 0, 0.12) !important;
}
.preview {
  // border-top: 1px solid rgba(0, 0, 0, 0.12);
}
.sitebar {
  position: absolute;
  height: 100%;
  width: $width;
}
.overlay-container {
  margin-left: 0;
  position: relative;
  height: 100%;
  width: calc(100%);
}
.inner-overlay-container {
  position: absolute;
  width: 100%;
  height: 100%;
}
.meta {
  border-left: 1px solid rgba(0, 0, 0, 0.12);
  position: relative;
  width: 350px;
  max-width: 350px;
  min-width: 350px;
}
.group-closed {
  /* max-width: 356px; */
  max-width: 80px;
}
.group {
  max-width: 256px;
}
.scroll-box {
  width: 100%;
}
.title {
  max-width: 80%;
}
.loading-bar {
  margin-bottom: -10px;
}
.group-navigation {
  font-size: 10px !important;
}
.overflow {
  overflow-y: scroll;
}
.asset-card {
  height: 100%;
  overflow: hidden;
  position: relative;
}
.content-area-nomax {
  position: relative;
  width: 100%;
  height: 100%;
}
.scroll {
  /* position: absolute; */
  width: 100%;
  height: 100%;
  overflow-y: scroll;
}
.action-area {
  width: 100%;
}
.subheader {
  font-size: 0.7em;
}
.header {
  width: 100%;
}
textarea {
  width: 100%;
  resize: none;
  border: 1px solid transparent;
  border-radius: 2px;
  outline: none;
  padding: 3px;
  box-sizing: border-box;
  margin-left: -3px;
}
textarea:focus {
  border: 1px solid var(--dark-blue);
}
</style>
